import * as React from "react";

const SvgIcnChannel = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.5 4a2.5 2.5 0 012.49 2.283l.827.236a.5.5 0 01.084.929l-.084.033-.818.233L20 12a6 6 0 01-6 6v2h1.5a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L15.5 21h-2a.5.5 0 01-.492-.41L13 20.5V18h-3v2h1.5a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L11.5 21h-2a.5.5 0 01-.492-.41L9 20.5V18H4.733a1 1 0 01-.745-1.666L14.105 5.002A3.002 3.002 0 0116.343 4H17.5zm0 1h-1.157a2 2 0 00-1.373.546l-.119.122L4.733 17H14a4.999 4.999 0 004.995-4.783L19 12V6.5a1.5 1.5 0 00-1.356-1.493L17.5 5zM17 6a1 1 0 110 2 1 1 0 010-2z"
        />
    </svg>
);

export default SvgIcnChannel;
